export enum CrkStatuses {
	ERROR_MODULE = 1006,
	VALID_STATUS = 0,
	WAITING_MUNIS = 326001
}

export interface SignTimerId {
	id: number | null
}

export interface DigitalSignResultData {
	base64ToString: string
	sign: string
}

export interface DigitalSignatureData {
	signature: DigitalSignResultData
}

export interface DigitalSignCommonData extends Pick<DigitalSignResultData, 'sign'> {
	object: string
}

export interface DigitalSignResult {
	result?: DigitalSignResultData
	error?: string
}